module.exports = __webpack_public_path__ + "img/trust-process4.fe7f2b2e.png";